import { FC } from "react";
import { BoundingBox } from "@models/character";
import styled from "@emotion/styled";
import { Box } from "@mui/material";

const FaceBoundingBox = styled(Box)`
  position: absolute;
  border-width: 2px;
  border-color: #1e64ddff;
  border-style: solid;
`;

const Image = styled.img`
  width: 100%;
`;

const FaceSelect: FC<{ url: string; boundingBox: BoundingBox }> = ({
  url,
  boundingBox,
}) => {
  return (
    <Box position="relative" maxWidth="500px">
      <Image src={url} />
      <FaceBoundingBox
        top={`${boundingBox.top * 100}%`}
        left={`${boundingBox.left * 100}%`}
        width={`${boundingBox.width * 100}%`}
        height={`${boundingBox.height * 100}%`}
      />
    </Box>
  );
};

export default FaceSelect;
